import React, { useEffect, useLayoutEffect, useState } from "react";
import { Box, InputAdornment, Tab, Tabs, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTE_COMPANY_DETAILS, ROUTE_COMPANY_JOBS_DASHBOARD, ROUTE_COMPANY_LIST, ROUTE_JOBS_DASHBOARD, ROUTE_MAIN, ROUTE_PROFILE_SETTINGS, ROUTE_REPORTS, ROUTE_USER_LIST, ROUTE_VIDEO_DETAILS } from "../../constants/routes";
import { useDispatch, useSelector } from "react-redux";
import { setB2BActiveTab } from "../../redux/actions/b2bActions";
import LogoutIcon from '@mui/icons-material/Logout';
import { logoutClear } from "../../redux/actions/appActions";
import NotificationNavButton from "../common/NotificationNavButton";

const B2BHeader = ({selectedindex}: {selectedindex?: any}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.app.user);
  const { activeTab } = useSelector((state: any) => state.b2b);
  const userDetail = user?.user || {};
  const { roleName } = userDetail?.roleDetail || {};
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  useEffect(() => {
    const updateScrollbarWidth = () => {
      setScrollbarWidth(window.innerWidth - document.documentElement.clientWidth);
    };

    window.addEventListener("resize", updateScrollbarWidth);
    updateScrollbarWidth();
    return () => window.removeEventListener("resize", updateScrollbarWidth);
  }, []);

  const handleChange = (event: any, newValue: any) => {
    dispatch(setB2BActiveTab(newValue));
  };


  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    setLogoutDialogOpen(false);
    dispatch(logoutClear(()=>{
        navigate(ROUTE_MAIN, { replace: true });
    }));
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  // Get selected tab index based on current route
  // useEffect(() => {
  //   const path = window.location.pathname;
  //   let tabIndex = 6;

  //   if (path === ROUTE_JOBS_DASHBOARD || path === ROUTE_VIDEO_DETAILS) {
  //     tabIndex = 0;
  //   } else if (path === ROUTE_USER_LIST) {
  //     tabIndex = 1;
  //   } else if (path === ROUTE_COMPANY_LIST) {
  //     tabIndex = 2;
  //   }  else if (path === ROUTE_COMPANY_DETAILS) {
  //     tabIndex = 2;
  //   } else if (path === ROUTE_COMPANY_JOBS_DASHBOARD) {
  //     tabIndex = 3;
  //   }
  //   else if (path === ROUTE_PROFILE_SETTINGS) {
  //     tabIndex = 1;
  //   }
  //   else {
  //     tabIndex = 0;
  //   }

  //   dispatch(setB2BActiveTab(tabIndex));
  // }, [navigate, roleName]);

  const atciveTapIndex = (tab: string) => {
    switch (tab) {
      case "videos-or-jobs":
        return 0; // Index for "My Jobs" or "Videos"  
      case "users":
        return 1; // Index for "Users"
      case "companies":
        return 2; // Index for "Companies"
      case "profile":
        return 1; // Index for "Profile"
      case "company":
        return 2; // Index for "Company"
      case "jobs":
        return 3; // Index for "Jobs"
      case "reports":
        return 4; // Index for "Reports"
      default:
        return false; // No tab selected
    }
  };
  useLayoutEffect(() => {
    // Set the active tab based on the current URL path
    const path = window.location.pathname;
    if (path === ROUTE_JOBS_DASHBOARD || path.includes('client-job-details') || path === ROUTE_VIDEO_DETAILS) {
      dispatch(setB2BActiveTab(roleName === "seevi_admin".toUpperCase() ? atciveTapIndex("videos-or-jobs") : atciveTapIndex("videos-or-jobs")));
    } else if (path === ROUTE_USER_LIST) {
      dispatch(setB2BActiveTab(atciveTapIndex("users")));
    } else if (path === ROUTE_COMPANY_LIST 
      || path.includes('company-details')
        || path.includes('company-edit')
        || path.includes('company-new')
        || path.includes('company-list')
    ) {
      dispatch(setB2BActiveTab(atciveTapIndex("companies")));
    } else if (path === ROUTE_PROFILE_SETTINGS) {
      dispatch(setB2BActiveTab(atciveTapIndex("profile")));
    } else if (path === ROUTE_COMPANY_DETAILS) {
      dispatch(setB2BActiveTab(atciveTapIndex("company")));
    } else if (path === ROUTE_COMPANY_JOBS_DASHBOARD 
      || path.includes('company/create-job') 
      || path.includes('client-job-details') || path.includes('company-job-details')) {
      dispatch(setB2BActiveTab(atciveTapIndex("jobs")));
    } else if (path === ROUTE_REPORTS) {
      dispatch(setB2BActiveTab(atciveTapIndex("reports")));
    }
    else {
      dispatch(setB2BActiveTab(atciveTapIndex("")));
    }
  }, [navigate, roleName]);
  

  return (
    <Box
      sx={{
        backgroundColor: "#756DE9",
        width: "100%",
        height: { xs: "auto", md: "75px" },
        boxShadow: "0px 1px 6px 0px #003A5D1A",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", md: "space-between" },
        px: { xs: 2, md: 4 },
        boxSizing: "border-box",
        paddingTop: { xs: "20px", md: "0" },
        gap: { xs: 2, md: 0 },
        paddingRight: `${scrollbarWidth}px`, // Prevents content shift
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src="/images/client-website/seevi-logo.png"
        alt="Logo"
        sx={{
          width: "83px",
          height: "36px",
          position: { xs: "relative", md: "absolute" },
          left: { md: "32px" },
          top: { md: "16px" },
          mb: { xs: 2, md: 0 },
        }}
        onClick={() => navigate(ROUTE_JOBS_DASHBOARD)}
      />

      {/* Tabs */}
      <Box
        sx={{
          position: { xs: "relative", md: "absolute" },
          left: { md: "50%" },
          transform: { md: "translateX(-50%)" },
          width: "750px", // Fixed width to prevent shifting
          height: "60px",
          backgroundColor: "#6352CC80",
          borderRadius: "100px",
          boxShadow: "4px 4px 10px 0px #5750C3 inset",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: { xs: "20px", md: "0px" },
          paddingX: 1,
        }}
      >
        <Tabs
          value={activeTab || 0}
          onChange={handleChange}
          sx={{
            minHeight: "20px",
            width: "100%", // Ensures tabs take full available space
            "& .MuiTabs-flexContainer": {
              justifyContent: "center",
            },
            "& .MuiTab-root": {
              flex: 1, // Makes all tabs equal width
              minWidth: "120px",
              padding: "0 20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#5750C3",
              borderRadius: "50px",
              height: "20px",
            },
          }}
          TabIndicatorProps={{
            sx: { display: "none" },
          }}
        >
          {[
            <Tab
              key="videos-or-jobs"
              label={roleName === "seevi_admin".toUpperCase() ? "Videos" : "My Jobs"}
              onClick={() => (roleName === "seevi_admin".toUpperCase() ? navigate(ROUTE_VIDEO_DETAILS) : navigate(ROUTE_JOBS_DASHBOARD))}
            />,
            ...(roleName === "seevi_admin".toUpperCase()
              ? [
                  <Tab key="users" label="Users" onClick={() => navigate(ROUTE_USER_LIST)} />,
                 <Tab key="companies" label="Companies" onClick={() => navigate(ROUTE_COMPANY_LIST)} />,
                  <Tab key="jobs" label="Jobs" onClick={() => navigate(ROUTE_COMPANY_JOBS_DASHBOARD)} />,
                  <Tab key="reports" label="Reports" onClick={() => navigate(ROUTE_REPORTS)} />,

                ]
              : [
                  <Tab key="profile" label="Profile" onClick={() => navigate(ROUTE_PROFILE_SETTINGS)} />,
                  <Tab key="company" label="Company" onClick={() => navigate(ROUTE_COMPANY_DETAILS)} />,
                ]), 
          ]}
        </Tabs>
        
      </Box>
      <Box
        sx={{
          position: { xs: "relative", md: "absolute" },
          right: { md: "1%" },
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <NotificationNavButton iconColor="#fff" />
        <Box onClick={handleLogoutClick} sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
          <InputAdornment position="end" style={{ color: "#fff", padding: "4px 6px", width: 20, height: 50 }}>
            <LogoutIcon />
          </InputAdornment>
        </Box>
      </Box>

      {/* Logout Confirmation Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
          }
        }}
      >
        <DialogTitle
          id="logout-dialog-title"
          sx={{
            color: '#f44336',
            fontWeight: 600,
            fontSize: '1.25rem',
            textAlign: 'center',
          }}
        >
          Confirm Logout
        </DialogTitle>
        <DialogContent>
          <Typography
            id="logout-dialog-description"
            sx={{
              textAlign: 'center',
              color: '#666',
              fontSize: '1rem',
              padding: '8px 0',
            }}
          >
            Are you sure you want to logout?
            <br />
            You will need to sign in again to access your account.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: '16px 24px' }}>
          <Button
            onClick={handleLogoutCancel}
            variant="outlined"
            sx={{
              borderColor: '#756DE9',
              color: '#756DE9',
              '&:hover': {
                borderColor: '#5a52d5',
                backgroundColor: 'rgba(117, 109, 233, 0.08)',
              },
              borderRadius: 2,
              paddingX: 3,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#f44336',
              '&:hover': {
                backgroundColor: '#d32f2f',
              },
              borderRadius: 2,
              paddingX: 3,
              minWidth: 100,
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default B2BHeader;
